import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import theme from '../theme'
import {ReactComponent as IconoDown} from '../imagenes/down.svg'
import Api from '../servicios/api';

const ContenedorSelect = styled.div`
    background: ${theme.grisClaro};
    cursor: pointer;
    border-radius: 0.625rem; /* 10px */
    position: relative;
    height: 3rem; /* 80px */
    margin-top: 0.4rem;
    padding: 0px 0.5rem; /* 20px */
    font-size: 1rem; /* 24px */
    text-align: center;
    display: flex;
    align-items: center;
    transition: .5s ease all;
    &:hover {
        background: ${theme.grisClaro2};
    }
`;
 
const OpcionSeleccionada = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 0.4rem;
    justify-content: space-between;
    svg {
        width: 0.8rem; /* 20px */
        height: auto;
        margin-left: 1rem; /* 20px */
    }
`;
 
const Opciones = styled.div`
    background: ${theme.grisClaro};
    position: absolute;
    top: 3.5rem; /* 90px */
    left: 0;
    width: 100%;
    border-radius: 0.625rem; /* 10px */
    max-height: 18.75rem; /* 300px */
    overflow-y: auto;
`;
 
const Opcion = styled.div`
    padding: 0.5rem; /* 20px */
    display: flex;
    svg {
        width: 28px;
        height: auto;
        margin-right: 1rem; /* 20px */
    }
    &:hover {
        background: ${theme.grisClaro2};
    }
`;

const SelectAutor = ({selectAutor, setSelectAutor, mostrarSelect, desactivarSelects}) => {
    const [listaAutores, setListaAutores] = useState([]);

    const handleClick = (e) => {
        setSelectAutor({Aut_ID:e.currentTarget.dataset.id, Aut_Nombre:e.currentTarget.dataset.valor});
    }

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        setSelectAutor({Aut_ID:0, Aut_Nombre: 'Seleccione Autor'})
        fetch(Api+"?consultarAutores")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setListaAutores(datosRespuesta);
        })
        .catch(console.log)
    }, [setSelectAutor]);

    return (
        <ContenedorSelect onClick={() => desactivarSelects()}>
            <OpcionSeleccionada>{selectAutor.Aut_Nombre}<IconoDown /></OpcionSeleccionada>

            {mostrarSelect && listaAutores.length > 0 &&
                <Opciones>
                    {listaAutores.map((autor) => {
                        return <Opcion 
                                    key={autor.Aut_ID}
                                    data-id={autor.Aut_ID}
                                    data-valor={autor.Aut_Nombre}
                                    onClick={handleClick}
                                >
                                    {autor.Aut_Nombre}
                                </Opcion>
                    })}
                </Opciones>
            }
        </ContenedorSelect>
    );
}

export default SelectAutor;